module.exports = __webpack_public_path__ + "static/media/zendrop.c6b6f9d3.svg";